import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS = defineFcm('revenue_subs_one_time_contributions')
	.asBoolean()
	.withDefault(false)
	.toConfig();
